import { render, staticRenderFns } from "./ReportLoading.vue?vue&type=template&id=bef21a46"
import script from "./ReportLoading.vue?vue&type=script&lang=js"
export * from "./ReportLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports